<template>
    <div id="rechargelist">
        <div class="head-tool">
            <span @click="$router.go(-1)">返回</span>
            <span class="tc">充值记录</span>
            <router-link class="tr" tag="span" to="/">首页</router-link>
        </div>
        <p class="alert">如您对充值有疑问，请点击「继续充值」- 「已完成支付」</p>
        <ul>
            <li v-for="val in list">
                <div class="fl">
                    <h4>{{val.orders}}</h4>
                    <p class="time">充值{{val.money}}</p>
                    <p class="time">  {{val.create_time}}</p>
                </div>
                <div class="fr">
                    <span v-if="val.status == 1" style="color:green">充值成功</span>
                    <span v-if="val.status == -1" style="color:#ddd">订单关闭</span>
                    <span v-if="val.status == 0" @click="doRecharge(val.orders)">继续充值</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Rechargelist",
        data(){
            return {
                list : [],
                page : 1,
                last_page : 1,

            }
        },methods:{
            getRechargeList(){
                this.axios.post('/api/orders/getOrdersList',{
                    page : this.page,
                }).then(r => {
                    let data = r.data;
                    if(data.code){
                        data.data.data.forEach(v=>{
                            this.list.push(v)
                        })
                    }
                })
            },
            doRecharge(orders){
                location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + orders;
            }
        },created() {
            this.getRechargeList();
        }
    }
</script>

<style lang="less">
    #rechargelist{background: #f6f6f7;overflow: auto;height: 100%;
        .head-tool{display: flex;padding: 26px 20px;background: #fff;border-bottom: 1px solid #efefef;
            span{flex:1;font-size: 30px;color:#333;
                i{font-size: 30px;}
            }
        }
        .alert{background: #fdf6ec;color: #e6a23c;padding: 20px;font-size: 26px;}
        ul{overflow: auto;height:calc(100% - 100px);background: #fff;
            li{padding: 20px;border-bottom: 1px solid #efefef;overflow: auto;
                h4{font-size: 30px;font-weight: 400;color: #333;}
                .time{color: #666;font-size: 26px;}
                .fr{padding-top: 40px;font-size: 26px;color:#333;}
            }
        }


    }
</style>
